export default __webpack_public_path__ + "static/media/NHaasGroteskTXPro-55Rg.69ec3dbc.ttf";